// extracted by mini-css-extract-plugin
export default {"icon":"icon__IAL0E"};